import DispexInput from './DispexInput';
import { typeKeys } from './config';

export default DispexInput;
export { typeKeys as typeInput };
